 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLFRONTMATTER from '@/components/xhtml/frontmatter'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFRONTMATTER01 from '@/components/xhtml/frontmatter01'
 import XHTMLPART01 from '@/components/xhtml/part01'
 import XHTMLPART01CHAPTER01 from '@/components/xhtml/part01chapter01'
 import XHTMLPART01CHAPTER02 from '@/components/xhtml/part01chapter02'
 import XHTMLPART01CHAPTER03 from '@/components/xhtml/part01chapter03'
 import XHTMLPART01CHAPTER04 from '@/components/xhtml/part01chapter04'
 import XHTMLPART01CHAPTER05 from '@/components/xhtml/part01chapter05'
 import XHTMLPART01CHAPTER06 from '@/components/xhtml/part01chapter06'
 import XHTMLPART01CHAPTER07 from '@/components/xhtml/part01chapter07'
 import XHTMLPART01CHAPTER08 from '@/components/xhtml/part01chapter08'
 import XHTMLPART02 from '@/components/xhtml/part02'
 import XHTMLPART02CHAPTER01 from '@/components/xhtml/part02chapter01'
 import XHTMLPART02CHAPTER02 from '@/components/xhtml/part02chapter02'
 import XHTMLPART02CHAPTER03 from '@/components/xhtml/part02chapter03'
 import XHTMLPART02CHAPTER04 from '@/components/xhtml/part02chapter04'
 import XHTMLPART02CHAPTER05 from '@/components/xhtml/part02chapter05'
 import XHTMLPART02CHAPTER06 from '@/components/xhtml/part02chapter06'
 import XHTMLPART02CHAPTER07 from '@/components/xhtml/part02chapter07'
 import XHTMLPART03 from '@/components/xhtml/part03'
 import XHTMLPART03CHAPTER01 from '@/components/xhtml/part03chapter01'
 import XHTMLPART03CHAPTER02 from '@/components/xhtml/part03chapter02'
 import XHTMLPART03CHAPTER03 from '@/components/xhtml/part03chapter03'
 import XHTMLPART03CHAPTER04 from '@/components/xhtml/part03chapter04'
 import XHTMLPART04 from '@/components/xhtml/part04'
 import XHTMLPART04CHAPTER01 from '@/components/xhtml/part04chapter01'
 import XHTMLPART04CHAPTER02 from '@/components/xhtml/part04chapter02'
 import XHTMLPART04CHAPTER03 from '@/components/xhtml/part04chapter03'
 import XHTMLPART04CHAPTER04 from '@/components/xhtml/part04chapter04'
 import XHTMLBACKMATTER01 from '@/components/xhtml/backmatter01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/frontmatter01",
 			"name" : "xhtml/frontmatter01",
 			"component" : XHTMLFRONTMATTER01
 		},
 		{
 			"path" : "/xhtml/part01",
 			"name" : "xhtml/part01",
 			"component" : XHTMLPART01
 		},
 		{
 			"path" : "/xhtml/part01chapter01",
 			"name" : "xhtml/part01chapter01",
 			"component" : XHTMLPART01CHAPTER01
 		},
 		{
 			"path" : "/xhtml/part01chapter02",
 			"name" : "xhtml/part01chapter02",
 			"component" : XHTMLPART01CHAPTER02
 		},
 		{
 			"path" : "/xhtml/part01chapter03",
 			"name" : "xhtml/part01chapter03",
 			"component" : XHTMLPART01CHAPTER03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js